// this gets instantiated by NotificationService.vue for global use
import { ref } from 'vue'

export const notification = {
  toast: null,
  confirm: null,
  dialog: null,
  loading: ref(0),
}
